import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useTitle } from '../TitleContext';

const TermsOfService = () => {
  const [content, setContent] = useState('');
  const { defaultTitle } = useTitle();
  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL}/termsofuse.txt`)
      .then((res) => res.text())
      .then(setContent)
      .catch((err) => console.error('Failed to load terms:', err));
  }, []);
  return (
    <div style={{ padding: '20px', whiteSpace: 'pre-wrap' }}>
      <Helmet>
        <title>{`${defaultTitle} - 利用規約`}</title>
      </Helmet>
      <h1>利用規約</h1>
      <div>{content}</div>
    </div>
  );
};

export default TermsOfService;